import React from 'react';
import EncounterDiagnosesPanel from './EncounterDiagnosesPanel';
import PatientClinicalNotesTab from '../patient/PatientClinicalNotesTab';
import { EmrClinicalNote } from '@/services/emrService';

interface ChartPanelProps {
  notes: EmrClinicalNote[];
  pagination: { page: number; limit: number; total: number; totalPages: number };
  onPaginationChange: (page: number) => void;
  refetch: () => void;
  patientId: string;
}

/**
 * Phase 4 — combined "Chart" tab. Stacks today's diagnoses on top (so the
 * practitioner can lock in the assessment while writing) and the SOAP notes
 * editor below.
 *
 * The IntelliHealth-backed SOAP autofill ("Fill from IntelliHealth") is
 * exposed inside NoteFormDrawer's AI banner whenever the drawer opens with
 * encounter context — no separate top-level button needed here.
 */
const ChartPanel: React.FC<ChartPanelProps> = ({
  notes, pagination, onPaginationChange, refetch, patientId,
}) => {
  return (
    <div className='space-y-6'>
      <EncounterDiagnosesPanel />
      <PatientClinicalNotesTab
        isLoading={false}
        notes={notes}
        pagination={pagination as never}
        onPaginationChange={onPaginationChange}
        refetch={refetch}
        patientId={patientId}
      />
    </div>
  );
};

export default ChartPanel;
